@file:Suppress("UNUSED_PARAMETER")

package ui.device.detail.editor

import androidx.compose.runtime.*
import common.frontend.api.*
import io.Repository
import kotlinx.coroutines.launch
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.printStackTraceInDebug
import ui.snackBarStateGlobal

@VM
class DeviceEditorVM : NavigationViewModel() {

    var isLoading by mutableStateOf(false)
        private set
    private lateinit var scopeUi: DeviceEditorScope

    var state by mutableDataState<DeviceEditorScope.Wrapper>()
        private set


    sealed interface Action {
        data object Save : Action

        companion object {

            @Composable
            fun rememberAction(vm: DeviceEditorVM): (Action) -> Unit {
                val nav = LocalNavigation.current
                return remember {
                    { act ->
                        when (act) {
                            Save -> vm.save(nav)
                        }
                    }
                }
            }
        }
    }

    private fun save(nav: Navigation) {
        isLoading = true
        scope.launch {
            state.entry?.apply {
                runCatching {
                    Repository.api.device.editorSet(data)
                }.onSuccess {
                    isLoading = false
                    nav.up()
                }.onFailure {
                    isLoading = false
                    snackBarStateGlobal.showSnackbar(it.message ?: "Fail to save changes")
                }
            }

        }
    }

    fun init(scopeUi: DeviceEditorScope) {
        this.scopeUi = scopeUi
        if (state is DataState.Result) return

        scope.launch {
            runCatching {
                val data =
                    if (scopeUi.args.registrationDeviceKey.isNotEmpty()) {
                        Repository.api.device.registration(scopeUi.args.registrationDeviceKey, scopeUi.lang).also {
                            scopeUi.args.deviceId = it.id
                        }
                    } else {
                        Repository.api.device.editorGet(scopeUi.args.deviceId, scopeUi.lang)
                    }

                state = DataState.Result(
                    entry = DeviceEditorScope.Wrapper(
                        registrationMode = scopeUi.args.registrationDeviceKey.isNotEmpty(),
                        data = data,
                        canEditLayers = scopeUi.login.canLayerTopEdit(data.companyId) && scopeUi.login.canLayerBottomEdit(data.companyId),
                        canEditLocation = scopeUi.login.canLocationView(data.companyId),
                        canEditCompany = scopeUi.login.canCompanyView(data.companyId),
                        canEditDisplay = scopeUi.login.canDeviceDisplayEdit(data.companyId)
                    ).apply {
                        setup()
                    }
                )
            }.onFailure {
                it.printStackTraceInDebug()
                state = DataState.Error(it.message!!, throwable = it)
            }
        }
    }

    override fun onRelease() {
        state = DataState.Idle()
    }

}
